import { Button, PopoverInteractionKind } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import React, { useContext, useEffect, useState } from "react";
import { StoresContext } from "../../../../pages/_app";
import { NODE_IDX, NODE_NAME, NODE_PARENT, TreeNode } from "../../../../stores/catalog-tree-store";
import { MAX_ITEMS_IN_BREADCRUMBS } from "./constants";

export const GenomesTreeBreadcrumbs = ({
  visibleIndexes,
  nodes,
}: {
  visibleIndexes: number[];
  nodes: TreeNode[];
}) => {
  const rootStore = useContext(StoresContext);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  useEffect(() => {
    setIsExpanded(false);
  }, [visibleIndexes]);

  if (visibleIndexes.length === 0) {
    return null;
  }
  const rootIdx = visibleIndexes[0]!;
  if (rootIdx === 0) {
    // There is no reason to display breadcrumbs. We are displaying full tree anyway
    return null;
  }

  const breadcrumbNodes: TreeNode[] = [];
  let current: TreeNode = nodes[rootIdx];
  while (true) {
    breadcrumbNodes.push(current);

    const parentIdx = current[NODE_PARENT];
    if (parentIdx === null) {
      break;
    }
    current = nodes[parentIdx];
  }
  breadcrumbNodes.reverse();

  let items = breadcrumbNodes.map((node) => (
    <li key={node[NODE_IDX]}>
      <a
        className={`bp4-breadcrumb ${rootIdx === node[NODE_IDX] ? "bp4-breadcrumb-current" : ""}`}
        href="#select-node"
        onClick={(event) => {
          event.preventDefault();
          if (rootIdx !== node[NODE_IDX]) {
            rootStore.catalogTreeStore.setNewParent(node[NODE_IDX]);
          }
        }}
      >
        {node[NODE_NAME]}
      </a>
    </li>
  ));

  if (!isExpanded && items.length > MAX_ITEMS_IN_BREADCRUMBS) {
    items = [
      items[0],
      <li key="expand">
        <Popover2
          content={"Expand"}
          placement={"top"}
          interactionKind={PopoverInteractionKind.HOVER}
          popoverClassName="info-tooltip info-tooltip--small"
        >
          <Button minimal={true} text={"..."} onClick={() => setIsExpanded(true)} />
        </Popover2>
      </li>,
      ...items.slice(items.length - MAX_ITEMS_IN_BREADCRUMBS),
    ];
  }

  return (
    <div className="breadcrumbs">
      <ul className="bp4-breadcrumbs inner-breadcrumbs">{items}</ul>
    </div>
  );
};
